import React, {useEffect, useState} from "react";
import ABDMApi from "../ABDMApi";
import JsonViewer from "./JsonViewer";
import {copyToClipboard} from "../ABDMUtils";
import LoadingButton from "./LoadingButton";
export default function ApiCard({
                                    title,
                                    description,
                                    url,
                                    method = "GET",
                                    payload = {},
                                    buttonText = "Execute",
                                    onSuccess = () => {
                                    }
                                }) {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("");
    const [elapsed, setElapsed] = useState("");
    const [response, setResponse] = useState(null);
    const [requestBody, setRequestBody] = useState(JSON.stringify(payload, null, 4));
    const [jsonError, setJsonError] = useState("");
    /*
    ============================================================
    UPDATE TEXTAREA WHEN PAYLOAD CHANGES
    ============================================================
    */
    useEffect(() => {
        setRequestBody(JSON.stringify(payload, null, 4));
    }, [payload]);
    /*
    ============================================================
    EXECUTE
    ============================================================
    */
    const execute = async () => {
        setLoading(true);
        setStatus("");
        setJsonError("");
        const start = performance.now();
        try {
            let parsedPayload = {};
            /*
            ====================================================
            PARSE JSON
            ====================================================
            */
            if (method === "POST" || method === "PUT" || method === "PATCH") {
                try {
                    parsedPayload = JSON.parse(requestBody);
                } catch (error) {
                    setJsonError("Invalid JSON. Please check the request body.");
                    setLoading(false);
                    return;
                }
            }
            /*
            ====================================================
            API CALL
            ====================================================
            */
            let result;
            if (method === "POST") {
                result = await ABDMApi.post(url, parsedPayload);
            } else if (method === "PUT") {
                result = await ABDMApi({
                    url, method, data: parsedPayload
                });
            } else if (method === "PATCH") {
                result = await ABDMApi({
                    url, method, data: parsedPayload
                });
            } else if (method === "DELETE") {
                result = await ABDMApi({
                    url, method, data: parsedPayload
                });
            } else {
                result = await ABDMApi({
                    url, method
                });
            }
            /*
            ====================================================
            RESPONSE
            ====================================================
            */
            const end = performance.now();
            setElapsed(Math.round(end - start));
            setStatus(result.status);
            setResponse(result.data);
            onSuccess(result.data);
        } catch (err) {
            const end = performance.now();
            setElapsed(Math.round(end - start));
            setStatus(err.response ? err.response.status : "ERROR");
            setResponse({
                success: false, error: err.message, details: err.response?.data
            });
        }
        setLoading(false);
    };
    /*
    ============================================================
    RENDER
    ============================================================
    */
    return (<div className="card shadow-sm mb-4 abdm-api-card">

        {/* =================================================
                HEADER
            ================================================= */}

        <div className="card-header bg-primary text-white">

            <strong>
                {title}
            </strong>

        </div>


        <div className="card-body">

            {/* =================================================
                    DESCRIPTION
                ================================================= */}

            {description && (<p className="text-muted">
                {description}
            </p>)}


            {/* =================================================
                    REQUEST BODY
                ================================================= */}

            {(method === "POST" || method === "PUT" || method === "PATCH") && (<div className="mb-3">

                <label className="form-label fw-bold">

                    Request Body

                </label>

                <textarea
                    className={`form-control ${jsonError ? "is-invalid" : ""}`}
                    value={requestBody}
                    onChange={(e) => {
                        setRequestBody(e.target.value);
                        setJsonError("");
                    }}
                    rows={16}
                    spellCheck={false}
                    style={{
                        fontFamily: "monospace", fontSize: "14px", resize: "vertical"
                    }}
                />

                {jsonError && (<div className="invalid-feedback">

                    {jsonError}

                </div>)}

            </div>)}


            {/* =================================================
                    EXECUTE
                ================================================= */}

            <LoadingButton

                loading={loading}

                text={buttonText}

                onClick={execute}

            />


            {/* =================================================
                    EXECUTED
                ================================================= */}

            <div className="small text-muted mb-2 mt-3">

                Executed :

                {" "}

                {new Date().toLocaleString()}

            </div>


            {/* =================================================
                    STATUS
                ================================================= */}

            {status !== "" && (<div className="mt-3">

                        <span
                            className={status >= 200 && status < 300 ? "badge bg-success" : "badge bg-danger"}
                        >

                            Status : {status}

                        </span>


                <span className="ms-3 badge bg-dark">

                            {elapsed} ms

                        </span>

            </div>)}


            {/* =================================================
                    RESPONSE
                ================================================= */}

            {response && (<JsonViewer
                title="Response"
                data={response}
            />)}

        </div>


        {/* =================================================
                FOOTER
            ================================================= */}

        <div className="d-flex mt-3 gap-2 p-3">

            <button
                className="btn btn-success"
                onClick={() => copyToClipboard(response)}
                disabled={!response}
            >

                Copy Response

            </button>


            <button
                className="btn btn-secondary"
                onClick={() => setResponse(null)}
            >

                Clear

            </button>

        </div>

    </div>);
}